import React from 'react'
import {PageWrap} from "../../Components";
import ApprovalList from "../../Containers/Vacation/ApprovalList";

const VacationApprovalListPage = () => (
    <PageWrap>
        <h3>휴가결재</h3>
        <ApprovalList/>
    </PageWrap>
)

export default VacationApprovalListPage
